<template>
    <AppModal :title="$t('labels.moving')" ref="AppModal">
        <div class="modal-body">
            <table class="table table-bordered table-striped table-hover mb-4">
                <thead>
                <tr>
                    <th>
                        <CheckBox
                            :modelValue="allValuesIsSelected"
                            @update:modelValue="selectAllValue"
                        />
                    </th>
                    <th>{{ $t('labels.type') }}</th>
                    <th>{{ $t('labels.amount') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, index) in rows">
                    <td>
                        <CheckBox
                            v-model="rows[index].identifier"
                            @input="selected => selectValue(selected, index, row.amount)"
                        />
                    </td>
                    <td>{{ row.type === 'exit-declaration' ? $t('labels.exit_declaration') : $t('labels.arrival_declaration')}}{{ ` (№${row.id})` }}</td>
                    <td>{{ row.type === 'exit-declaration' ? '-' : '+' }}{{ row.amount }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer d-flex justify-content-between">
            <span>{{ $t('table.titles.factual_amount') }} : <span class="font-weight-bold">{{ recalculateFactualAmount }} шт.</span></span>
            <AppButton size="sm"
                @click="editFactualAmount"
                color="teal"
            >
                {{ $t('buttons.edit') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import CheckBox from '../../../../../components/new/form/checkbox/AppCheckbox.vue';
import { httpClient } from '../../../../../services/HttpClient.ts';
import MessageNotificator from '../../../../../services/MessageNotificator';

export default {
    name: 'MovesModal',
    components: {
        AppModal,
        AppButton,
        CheckBox
    },
    props: {
        inventory: {
            type: Object,
            required: true
        },
        warehouse: {
            type: Object,
            default: null
        },
        exitDeclarationStatusUuids: {
            type: Array,
            default: () => []
        },
        arrivalDeclarationStatusUuids: {
            type: Array,
            default: () => []
        }
    },
    emits: ['updateTable'],
    data() {
        return {
            rows: [],
            factual_amount: 0,
            selectedIndexes: [],
            productItemUuid: null
        }
    },
    methods: {
        show(row) {
            if (row.last_change_factual_at !== null) {
                let date = Date.parse(row.last_change_factual_at)
                let dateObject = new Date(date)
                let formatDate = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1).toString().padStart(2, '0')}-${dateObject.getDate().toString().padStart(2, '0')}`

                httpClient.get('/management/warehouses/products/moves', {
                    product_uuids: [row.product_item_uuid],
                    from_date: row.last_change_factual_at === null ? null : formatDate,
                    warehouse_uuids: [this.warehouse?.uuid],
                    exit_declaration_status_uuids: this.exitDeclarationStatusUuids,
                    arrival_declaration_status_uuids: this.arrivalDeclarationStatusUuids,
                    limit: 0
                }).then((response) => {
                    this.rows = response.data.data.map(row => row = { ...row, identifier: false });
                    this.productItemUuid = row.uuid;
                })

                this.factual_amount = Number(row.factual_amount);
            }

            this.$refs.AppModal.show()
        },
        hide() {
            this.productItemUuid = null;
            this.selectedIndexes = [];
            this.factual_amount = 0;
            this.rows = [];
            this.$refs.AppModal.hide();
        },
        selectValue(selected, index) {
            if(selected) {
                this.selectedIndexes.push(index)
            } else {
                this.selectedIndexes = this.selectedIndexes.filter(item => item !== index)
            }
        },
        selectAllValue() {
            if(!this.allValuesIsSelected) {
                this.rows.map(function (row, index) {
                    if(row.identifier === false) {
                        this.selectedIndexes.push(index);
                        row.identifier = true
                    }}, this)
            } else {
                this.rows.map(item => item.identifier = false)
                this.selectedIndexes = []
            }
        },
        editFactualAmount() {
            httpClient.put(`/management/inventories/${this.inventory.uuid}/product-items/${this.productItemUuid}`, {
                fields: [
                    {
                        name: 'factual_amount',
                        value: this.recalculateFactualAmount
                    }
                ]
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.updated', {
                    model: this.$t('table.titles.factual_amount')
                }))
                this.$emit('updateTable')
                this.hide()
            })
        }
    },
    computed: {
        recalculateFactualAmount() {
            let newFactualAmount = this.factual_amount

            this.rows.map(function (item, index) {
                if(this.selectedIndexes.includes(index)) {
                    item.type === "arrival-declaration" ? newFactualAmount += Number(item.amount) : newFactualAmount -= Number(item.amount)
                }
            }, this)

            return newFactualAmount
        },
        allValuesIsSelected() {
            return this.rows.length === this.selectedIndexes.length
        }
    }
}
</script>

<style scoped>
#table-label{
    margin-left: 20px
}
</style>
